import { useContext } from 'react';
import { UserSecurityContext } from '../userSecurityProvider';

export const useUserSecurityState = () => {
  const security = useContext(UserSecurityContext) as any;

  return {
    setSecurity: security?.setSecurity,
    setIsSecurityLoading: security?.setIsSecurityLoading
  };
};
